import React from 'react';
import ErrorService from '../../services/ErrorService';

interface ErrorBoundaryProps {
  FallbackComponent: React.FC<any>;
  children: React.ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: any, errorInfo: any) {
    ErrorService.notify('ErrorBoundary', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <this.props.FallbackComponent />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
